/* Document navigation is optional; Shopify's policy text stays visible if JS fails. */
(function () {
  'use strict';
  if (window.__etPolicyDocuments) return;
  window.__etPolicyDocuments = true;
  var observers = new Map();
  var count = 0;
  function create(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }
  function setup(container) {
    if (container.dataset.policyReady) return;
    var nativePolicy = container.matches('.shopify-policy__container');
    var body = container.querySelector(nativePolicy ? '.shopify-policy__body' : '[data-policy-body]');
    if (!body) return;
    container.dataset.policyReady = 'true';
    var headings = Array.from(body.querySelectorAll('h2,h3')).filter(function (heading) { return heading.textContent.trim(); });
    if (nativePolicy) {
      var title = container.querySelector('.shopify-policy__title');
      if (title && !title.querySelector('.et-policy__eyebrow')) title.prepend(create('p', 'et-policy__eyebrow', 'Eleven Theory / The details'));
    }
    if (headings.length < 2) return;
    var aside = container.querySelector('[data-policy-aside]');
    var list;
    if (nativePolicy) {
      aside = create('aside', 'et-policy__aside');
      var nav = create('nav');
      nav.setAttribute('aria-label', 'On this page');
      nav.appendChild(create('p', 'et-policy__contents-label', 'On this page'));
      list = create('ol');
      nav.appendChild(list);
      aside.appendChild(nav);
      aside.appendChild(create('p', 'et-policy__aside-note', 'Clear words. No small print.'));
      container.insertBefore(aside, body);
      container.classList.add('et-policy--enhanced');
    } else {
      if (!aside) return;
      list = aside.querySelector('ol');
    }
    if (!list) return;
    var documentId = 'et-policy-' + (++count);
    var links = new Map();
    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var id = documentId + '-section-' + (index + 1);
        while (document.getElementById(id)) id += '-x';
        heading.id = id;
      }
      var item = create('li');
      var link = create('a', '', heading.textContent.trim());
      link.setAttribute('href', '#' + encodeURIComponent(heading.id));
      item.appendChild(link);
      list.appendChild(item);
      links.set(heading, link);
    });
    aside.hidden = false;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var intersecting = entries.filter(function (entry) { return entry.isIntersecting; });
        if (!intersecting.length) return;
        var target = intersecting[0].target;
        links.forEach(function (link, heading) {
          if (heading === target) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-110px 0px -55% 0px', threshold: 0 });
      headings.forEach(function (heading) { observer.observe(heading); });
      observers.set(container, observer);
    }
  }
  function init(root) {
    var containers = Array.from(root.querySelectorAll('[data-et-policy],.shopify-policy__container'));
    if (root.matches && root.matches('[data-et-policy],.shopify-policy__container')) containers.unshift(root);
    containers.forEach(setup);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    observers.forEach(function (observer, container) {
      if (event.target === container || event.target.contains(container)) { observer.disconnect(); observers.delete(container); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
}());
